<template>
    <div>

    <div id="hero-banner">
        <div class="bg-parallax banner-image" data-inverted="true" data-speed="0.1" :style="bannerStyle"></div>
        <div class="overlay text-center">
            <h1 id="hero-text">How it works</h1>
        </div>
    </div>

    <div>
        <!-- <img :src="bannerImage" class="company-banner"> -->
        <div class="container pt-8 pb-8">
            <div class="row justify-content-sm-center text-center">
                <div v-for="(slide, key) in slideImages" :key="key" class="col-xl-3 col-md-6 col-sm-12 how-it-works-step">
                    <h3 class="mb-3" v-text="slide.text"></h3>
                    <img :src="slide.image" alt="">
                </div>
            </div>
        </div>
    </div>

    </div>
</template>
<script>
import { resource } from "@utils/network";
export default {
    name: "HowItWorksPage",

    data: () => ({
        bannerImage: resource('images/About-Us-Banner-FB.jpg'),
        bannerStyle: `background-image:url('${ resource("images/how-it-works-bannerjpg.jpg") }')`,
        slideImages: [
            { text: "Select booking type", image: resource('images/how-it-works/select_booking_type.png') },
            { text: "Select location", image: resource('images/how-it-works/select_location.png') },
            { text: "Select your schedule", image: resource('images/how-it-works/select_your_schedule.png') },
            { text: "Select your shop", image: resource('images/how-it-works/select_your_shop.png') },
            { text: "Choose your services", image: resource('images/how-it-works/choose_your_services.png') },
            { text: "Select your experts", image: resource('images/how-it-works/select_your_experts.jpg') },
            { text: "Confirm booking", image: resource('images/how-it-works/confirm_booking.png') },
        ]
    })
}
</script>


<style scoped lang="css">
    #hero-banner {
        position: relative;
        height: 800px;
        overflow: hidden;
    }
    #hero-banner .banner-image {
        height: 100%;
    }
    #hero-text {
        margin-top: 400px;
        font-family: 'Montserrat', sans-serif;
        color: white;
        text-transform: uppercase;
        font-size: 3.8rem;
        font-weight: 800;
        line-height: 1.5;
    }
    #hero-banner .overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.6);
        top: 0px;
    }
    .company-banner {
        width: 100%;
    }
    .how-it-works-step {
        margin-bottom: 40px
    }
    .how-it-works-step img {
        position: relative;
        width: 100%;
        box-shadow: 0px 10px 20px 1px rgba(0,0,0,0.2);
    }
</style>